window.initDownloadable ?? (() => {
    window.initDownloadable = (section_id) => {

        const triggerKlaviyo = () => {
            const buttons = document.querySelectorAll(`section#shopify-section-${section_id} .careline-25-downloadable .button`);
            var _klOnsite = window._klOnsite || [];

            buttons.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    console.log(e);
                    let formId = e.currentTarget.dataset.id;
                    _klOnsite.push(['openForm', formId]);
                });
            });

            if(document.querySelectorAll('a[href="#download-guide"]').length > 0) {
                document.querySelectorAll('a[href="#download-guide"]').forEach(download_btn => {
                    download_btn.addEventListener('click', (e) => {
                        e.preventDefault();

                        for (const btn of buttons) {
                            if (btn.getClientRects().length > 0) {
                                btn.click();
                                break;
                            }
                        }
                    });
                });
            }
        
        }

        triggerKlaviyo();

    }
})();